import React from "react";
import "./Footer.scss"
import logo from "../../assets/logo-round.svg"
import insta from "../../assets/insta.svg"
import tt from "../../assets/tt.svg"
import fb from "../../assets/fb.svg"
import { useSelector } from "react-redux";
import { useHistory } from "react-router";
import phone from "../../assets/phone.svg"
import mail from "../../assets/mail.svg"
import location from "../../assets/location.svg"

const Footer = () => {
    const company = useSelector((state) => state.companyData.company);
    const companyDetails = useSelector((state) => state.companyData.companyDetails);
    const history = useHistory()
    const navs = [
        {
            "title": "Home",
            "href": "/"
        }, {
            "title": "Menu",
            "href": "/page/menu"
        }, {
            "title": "Contact",
            "href": "/page/contact"
        },
    ]
    return (
        <div className="Regal-Footer">
            <div className="Regal-Footer-inner">
                <div className="Regal-Footer-inner-details">
                    <div className="Regal-Footer-inner-details-header">
                        <img alt="" src={logo} />
                        Regal Sweet Mart
                    </div>
                    <div className="Regal-Footer-inner-details-content">
                        Discover India’s rich, authentic tastes paired with heartfelt hospitality at Regal Sweet Mart and Restaurant.
                    </div>
                    <div className="Regal-Footer-inner-details-social">
                        {company?.SocialMedias
                            ?.instagram && company?.SocialMedias
                                ?.instagram !== "" && <img alt='' src={insta}
                                    onClick={() => {
                                        window.open(company?.SocialMedias
                                            ?.instagram, '_blank')
                                    }} />}
                        {company?.SocialMedias
                            ?.tiktok && company?.SocialMedias
                                ?.tiktok !== "" && <img alt='' src={tt}
                                    onClick={() => {
                                        window.open(company?.SocialMedias
                                            ?.tiktok, '_blank')
                                    }} />}
                        {company?.SocialMedias
                            ?.facebook && company?.SocialMedias
                                ?.facebook !== "" && <img alt='' src={fb}
                                    onClick={() => {
                                        window.open(company?.SocialMedias
                                            ?.facebook, '_blank')
                                    }} />}
                    </div>
                </div>
                <div className="Regal-Footer-inner-details">
                    <div className="Regal-Footer-inner-details-header2">
                        Quick Links
                    </div>
                    {navs.map((nav, key) => {
                        return (
                            <div key={key}
                                onClick={() => {
                                    history.push(nav?.href)
                                }}
                                className="Regal-Footer-inner-details-content2">
                                {nav?.title}
                            </div>
                        )
                    })}
                </div>
                <div className="Regal-Footer-inner-details">

                    <div className="Regal-Footer-inner-details-header2">
                        Contact Us
                    </div>
                    <div className="Regal-Footer-inner-details-content3">
                        <img alt='' src={location} />
                        {companyDetails.address.line1}, {companyDetails.address.city},<br /> {companyDetails.address.postcode}, {companyDetails.address.country}

                    </div>
                    <div className="Regal-Footer-inner-details-content">
                        <img alt='' src={phone} />
                        {company?.Phone}
                    </div>
                    <div className="Regal-Footer-inner-details-content">
                        <img alt='' src={mail} />
                        {company?.Email}
                    </div>
                </div> <div className="Regal-Footer-inner-details">
                    <div className="Regal-Footer-inner-details-header2">
                        Opening Hours
                    </div>
                    <div className="Regal-Footer-inner-details-content4">
                        Monday - Friday<div style={{ width: "22px" }} />8.00 AM - 9.00 PM
                    </div>
                    <div className="Regal-Footer-inner-details-content4" style={{ marginTop: "0px" }}>
                        Saturday - Sunday<div style={{ width: "7px" }} />8.00 AM - 9.00 PM
                    </div>
                    <div className="Regal-Footer-inner-details-btn">
                        Get Directions
                    </div>
                </div>
            </div>
            <div className="Regal-Footer-bottom">
                © 2025 Regal Sweet Mart & Restaurant. All rights reserved.
            </div>
        </div>
    )
}
export default Footer